export const AMPLIFY_INIT = "[amplify] init"

export const initAmplify = () => ({
    type: AMPLIFY_INIT
})